export default class ToggleWeekModule {
  constructor() {
    this.transitionDuration = 300; // Duração da transição em ms
  }

  initialize() {}

  toggleWeek(event) {
    const button = event.currentTarget;
    const weekId = button.dataset.weekId;
    const weekGroup = this.findWeekGroup(weekId);

    if (!weekGroup) return;

    const weekContainer = this.findWeekContainer(weekGroup);
    if (!weekContainer) return;

    const isCurrentlyVisible = this.isContainerVisible(weekContainer);

    this.toggleIcons(button);

    if (isCurrentlyVisible) {
      this.closeWeekContainer(weekContainer);
    } else {
      this.openWeekContainer(weekContainer);
    }
  }

  findWeekGroup(weekId) {
    const weekGroupId = `week-group-${weekId}`;
    return document.getElementById(weekGroupId);
  }

  findWeekContainer(weekGroup) {
    return weekGroup.querySelector('[data-kanban-target="escalasContainer"]');
  }

  isContainerVisible(container) {
    return !container.style.height || container.style.height !== "0px";
  }

  toggleIcons(button) {
    const iconShow = button.querySelector(".icon-show");
    const iconHide = button.querySelector(".icon-hide");

    if (iconShow && iconHide) {
      iconShow.classList.toggle("hidden");
      iconHide.classList.toggle("hidden");
    }
  }

  closeWeekContainer(container) {
    // Guarda a altura original antes de fechar
    const originalHeight = container.scrollHeight;
    container.style.height = originalHeight + "px";

    // Força um reflow para que a transição funcione
    container.offsetHeight;

    // Anima para fechado
    container.style.height = "0px";
    container.style.opacity = "0";
    container.style.marginBottom = "0px";
  }

  openWeekContainer(container) {
    // Anima para aberto
    container.style.height = "auto";
    const autoHeight = container.scrollHeight;
    container.style.height = "0px";

    // Força um reflow
    container.offsetHeight;

    container.style.height = autoHeight + "px";
    container.style.opacity = "1";
    container.style.marginBottom = "1rem";

    // Após a transição, defina a altura como auto para permitir redimensionamento
    setTimeout(() => {
      container.style.height = "auto";
    }, this.transitionDuration);
  }
}
